import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTEmergencyResponseService } from "../../services/emergency-response/emergency-response.service";
import { DatePipe } from "@angular/common";
import { ERTEmergencyResponse } from "../../interfaces/emergencyresponse/emergencyresponse";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { ERTMedicalRunSheet } from "../../interfaces/emergencyresponse/medical-runsheet";
import { ERTMedicalRunSheetService } from "../../services/emergency-response/medical-runsheet.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable, Sort } from "@angular/material/sort";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-ert-emergency-response-view",
  templateUrl: "./ert-emergency-response-view.component.html",
  styles: [
    `
      ::ng-deep mat-expansion-panel-header .mat-expansion-indicator {
        display: none;
      }

      ::ng-deep mat-icon {
        color: white !important;
      }
    `,
  ],
})
export class ErtEmergencyResponseViewComponent implements OnInit {
  facilityName: string = "";
  incidentDateAndTime: string;
  commanderName: string;
  incidentCommanderId: number;
  emergencyResponseId: string;
  isUserUpdating: boolean = false;
  currentEmergencyResponse: ERTEmergencyResponse;

  mrsDataSource: MatTableDataSource<ERTMedicalRunSheet, MatPaginator> =
    new MatTableDataSource<any>([]);
  totalItems: number;
  sortedBy: string;
  pageSize = 5;

  ertEmergencyResponseViewForm: FormGroup;
  formErrors: any[] = [];
  ertUsers: ERTUser[] = [];

  empInfoPanelOpenState = true;
  responseTypePanelOpenState = true;
  reasonInfoPanelOpenState = true;
  resultsInfoPanelOpenState = true;
  commentsInfoPanelOpenState = true;

  displayedColumns: Map<string, string> = new Map<string, string>([
    ["id", "ERT Medical Run Sheet Number"],
    ["dateTimeIncidentOccurred", "Date and Time Incident Occurred"],
    ["chiefComplaint", "Chief Complaint"],
    ["dateTimePatientArrival", "Date and Time Patient Arrival"],
    ["actions", "Actions"],
  ]);
  displayedColumnsArray: string[] = Array.from(this.displayedColumns.keys());

  facilityId: number;

  currentUser: ILoggedUserData;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ertEmergencyResponseService: ERTEmergencyResponseService,
    private ertUserService: ERTUserService,
    private ertMedicalRunSheetService: ERTMedicalRunSheetService,
    private fb: FormBuilder,
    private loggedUser: LoggedUserService,
    private renderer: Renderer2,
    
  ) {
    this.ertEmergencyResponseViewForm = this.fb.group({
      facility: [""],
      incidentOccurredDateTime: [""],
      incidentClearedDateTime: [""],
      incidentCommander: ["", Validators.required],
      description: [""],
      medical: [""],
      fire: [""],
      rescue: [""],
      hazmat: [""],
      leak: [""],
      odor: [""],
      ertCallOut: [""],
      other: [""],
      otherDescription: [""],
      responseReason: [""],
      tactics: [""],
      results: [""],
      responders: [""],
      commentsInfo: [""],
    });
  }

  ngOnInit(): void {
    this.loggedUser.getLoggedUserData().subscribe((user) => {
      this.currentUser = user;
      this.facilityId = Number(user.facilityId) || 0;
      this.facilityName =
        this.facilityId === 2
          ? "Oronite Oak Point Plant"
          : user.facilityName || "";
      this.ertEmergencyResponseViewForm.patchValue({
        facility: this.facilityName,
      });

      this.ertUserService.getAllERTUsers(this.facilityId).subscribe((data) => {
        this.ertUsers = data;
        this.ertUsers = data.filter((user) =>
          user.picklistValues.some((picklist) => picklist.value === "PP")
        );
        this.ertUsers.sort((a, b) => a.lastName.localeCompare(b.lastName));
      });

      this.route.queryParamMap.subscribe((params) => {
      this.emergencyResponseId = params.get("emergencyResponseId");
      this.loadData(this.emergencyResponseId);
    });
    });
  }

  loadData(emergencyResponseId: string) {
    this.ertEmergencyResponseService
      .getERTEmergencyResponseById(Number(emergencyResponseId), Number(this.currentUser.facilityId) || 0)
      .subscribe({
        next: (data) => {
          if(data.facilityId != Number(this.currentUser.facilityId)) {
            this.router.navigate(["/no-access"]);
            return;
          }
          this.currentEmergencyResponse = data;
          this.incidentDateAndTime = this.formatDate(
            data.dateTimeIncidentOccured.slice(0, 16)
          );
          this.commanderName = data.incidentCommander.fullName;

          this.ertEmergencyResponseViewForm.patchValue({
            facility: this.facilityName,
            incidentOccurredDateTime: data.dateTimeIncidentOccured.slice(0, 16),
            incidentClearedDateTime: data.dateTimeIncidentCleared.slice(0, 16),
            incidentCommander: data.incidentCommander.fullName,
            description: data.description,
            medical: data.isMedical,
            fire: data.isFire,
            rescue: data.isRescue,
            hazmat: data.isHazmat,
            leak: data.isLeak,
            odor: data.isOdor,
            ertCallOut: data.isERTCallOut,
            other: data.isOther,
            otherDescription: data.otherDescription,
            responseReason: data.reasonForResponse,
            tactics: data.tactics,
            results: data.results,
            responders: data.responders,
            commentsInfo: data.comments,
          });
        },
        error: (error) => {},
      });

    this.ertMedicalRunSheetService
      .getERTMedicalRunSheetByEmergencyResponseId(Number(emergencyResponseId))
      .subscribe({
        next: (data) => {
          this.mrsDataSource = new MatTableDataSource<
            ERTMedicalRunSheet,
            MatPaginator
          >(data);
          this.totalItems = data.length;
          setTimeout(() => {
            this.mrsDataSource.sort = this.sort;
            this.mrsDataSource.paginator = this.paginator;
            this.sort.sort({
              id: "id",
              start: "asc",
            } as MatSortable);
            this.sort.sortChange.subscribe((sortState: Sort) => {
              this.onSortChange(sortState);
            });
            this.sortedBy = `Sorted by ${this.displayedColumns.get("id")}`;
          }, 10);
        },
        error: (error) => {},
      });
  }

  onSortChange(sortState: Sort) {
    if (sortState.direction.length > 0) {
      this.sortedBy = `Sorted by ${this.displayedColumns.get(
        sortState.active
      )}`;
    } else {
      this.sortedBy = "Not sorted";
    }
  }

  onPageChange(event: any) {
    const startIndex = event.pageIndex * event.pageSize;
    const endIndex = startIndex + event.pageSize;
    this.mrsDataSource.data = this.mrsDataSource.data.slice(
      startIndex,
      endIndex
    );
  }

  formatDate(input: string): string {
    if(input == null || input == undefined) {
      return "";  }
    const date = new Date(input);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = Number(hours) >= 12 ? "PM" : "AM";
    hours = (Number(hours) % 12).toString().padStart(2, "0");
    hours = Number(hours) ? hours : "12";
    const strTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year} ${strTime}`;
  }

  submitForm() {
    this.formErrors = [];
    if (this.ertEmergencyResponseViewForm.invalid) {
      this.formErrors.push("Form is invalid");
      return;
    }

    this.currentEmergencyResponse = {
      id: Number(this.emergencyResponseId),
      dateTimeIncidentOccured: this.ertEmergencyResponseViewForm.get(
        "incidentOccurredDateTime"
      ).value,
      dateTimeIncidentCleared: this.ertEmergencyResponseViewForm.get(
        "incidentClearedDateTime"
      )?.value,
      incidentCommanderId: this.getERTUserId(
        this.ertEmergencyResponseViewForm.get("incidentCommander")?.value
      ),
      incidentCommander: this.getIncidentCommander(this.incidentCommanderId),
      description: this.ertEmergencyResponseViewForm.get("description")?.value,
      isFire: this.ertEmergencyResponseViewForm.get("fire")?.value,
      isLeak: this.ertEmergencyResponseViewForm.get("leak")?.value,
      isMedical: this.ertEmergencyResponseViewForm.get("medical")?.value,
      isRescue: this.ertEmergencyResponseViewForm.get("rescue")?.value,
      isHazmat: this.ertEmergencyResponseViewForm.get("hazmat")?.value,
      isOdor: this.ertEmergencyResponseViewForm.get("odor")?.value,
      isERTCallOut: this.ertEmergencyResponseViewForm.get("ertCallOut")?.value,
      isOther: this.ertEmergencyResponseViewForm.get("other")?.value,
      otherDescription:
        this.ertEmergencyResponseViewForm.get("otherDescription")?.value,
      reasonForResponse:
        this.ertEmergencyResponseViewForm.get("responseReason")?.value,
      tactics: this.ertEmergencyResponseViewForm.get("tactics")?.value,
      results: this.ertEmergencyResponseViewForm.get("results")?.value,
      responders: this.ertEmergencyResponseViewForm.get("responders")?.value,
      comments: this.ertEmergencyResponseViewForm.get("commentsInfo")?.value,
      facilityId: Number(this.currentUser.facilityId) || 1,
      facility: null,
      createdById: null
    };

    this.ertEmergencyResponseService
      .updateERTEmergencyResponse(this.currentEmergencyResponse, Number(this.currentUser.facilityId) || 0)
      .subscribe({
        next: (data) => {
          this.isUserUpdating = false;
          this.router.navigate(["/ert-emergency-response/emergency-response-view"],
            {
              queryParams: {
                emergencyResponseId: this.emergencyResponseId,
              },
            }
          );
          this.scrollToTop();
        },
        error: (error) => {
          this.isUserUpdating = false;
          this.formErrors.push("Error updating emergency response");
        },
      });
  }

  private scrollToTop() {
    this.renderer.setProperty(document.documentElement, "scrollTop", 0);
    this.renderer.setProperty(document.body, "scrollTop", 0);
  }

  getERTUserId(fullName: string): number {
    const ertUser = this.ertUsers.find((user) => user.fullName === fullName);
    this.incidentCommanderId = ertUser ? ertUser.id : 0;
    return ertUser ? ertUser.id : 0;
  }

  getIncidentCommander(id: number): ERTUser {
    const ertUser = this.ertUsers.find((user) => user.id === id);
    return ertUser ? ertUser : null;
  }

  navigateToPrint(id: string): void {
    this.ertEmergencyResponseService.printEmergencyResponseForm(id, Number(this.currentUser.facilityId) || 0);
  }

  editMedicalRunsheet(id: number) {
    this.router.navigate(["/ert-emergency-response/medical-runsheet-view"], {
      queryParams: { medicalRunSheetId: id },
    });
  }

  deleteMedicalRunsheet(id: number) {
    if (
      !confirm(
        "Are you sure you want to delete this medical runsheet? This action cannot be undone."
      )
    ) {
      return;
    }
    this.ertMedicalRunSheetService
      .deleteERTMedicalRunSheet(id, this.facilityId)
      .subscribe((data) => {
        this.loadData(this.emergencyResponseId);
      });
  }
}
